/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderlineViewDTO } from '../models/OrderlineViewDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OrderlinesService {

    /**
     * @param key 
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns OrderlineViewDTO Success
     * @throws ApiError
     */
    public static getBackendOrdersOrderlines(
key: number,
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<Array<OrderlineViewDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backend/orders/{key}/Orderlines',
            path: {
                'key': key,
            },
            query: {
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param key 
     * @param id 
     * @returns OrderlineViewDTO Success
     * @throws ApiError
     */
    public static getBackendOrdersOrderlines1(
key: number,
id: number,
): CancelablePromise<OrderlineViewDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backend/orders/{key}/Orderlines/{id}',
            path: {
                'key': key,
                'id': id,
            },
        });
    }

    /**
     * @param id 
     * @param key 
     * @param size 
     * @param filetype 
     * @returns any Success
     * @throws ApiError
     */
    public static getOrderlineThumbnail(
id: number,
key?: number,
size: number = 512,
filetype: string = 'webp',
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orderline/{id}/thumbnail',
            path: {
                'id': id,
            },
            query: {
                'key': key,
                'size': size,
                'filetype': filetype,
            },
        });
    }

    /**
     * @param id 
     * @param key 
     * @param size 
     * @param filetype 
     * @returns any Success
     * @throws ApiError
     */
    public static getOrderlinesThumbnail(
id: number,
key?: number,
size: number = 512,
filetype: string = 'webp',
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orderlines/{id}/thumbnail',
            path: {
                'id': id,
            },
            query: {
                'key': key,
                'size': size,
                'filetype': filetype,
            },
        });
    }

}
